<template>
  <div class="email_page" ref="middle_page">
    <span class="email_page_filter"></span>
    <div class="email_content">
      <div class="email_box">
        <div class="logo_font">
          <p>{{ $t("email.title") }}</p>
        </div>
        <div class="email_left">
          <p>{{ $t("email.email") }}</p>
        <p class="warning" >{{$t('email.emailWarning')}}</p>
        </div>
        <div class="email_center">
          <div class="input">
            <input
              :placeholder="$t('email.placeholder')"
              type="text"
              v-model="email"
            />
            <img src="../../../static/images/email.png" />
            <div class="line"></div>
          </div>
          <br />
          <div class="input">
            <input
              :placeholder="$t('email.confirmplaceholder')"
              type="text"
              v-model="confirmEmail"
            />
            <img src="../../../static/images/email.png" />
            <div class="line"></div>
          </div>
          <button @click="confirm()">{{ $t("email.confirm") }}</button>
          <button @click="returnButton()">
            {{ $t("common.returnButton") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//国际化引入
import Vue from "vue";
import { lang } from "../../assets/languages/getLanguageType.js";
Vue.prototype.$lang = lang;
export default {
  name: "email",
  data() {
    return {
      email: "", //email地址
      confirmEmail: ""
    };
  },
  mounted() {
    //获取设备屏幕的高度
    const h = document.body.clientHeight;
    this.$refs.middle_page.style.minHeight = h + "px";
  },
  methods: {
    //确定重置密码
    confirm: function() {
      //邮箱不可以为空
      if (this.email == null || this.email == "") {
        this.$el_alert_type(window.vm.$i18n.t("js.email"), "warning");
        return;
      }

      //验证邮箱格式
      let reg = new RegExp(
        /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
      );
      if (!reg.test(this.email)) {
        this.$el_alert_type(window.vm.$i18n.t("js.formatWrong"), "warning");
        return;
      }

      if (this.email != this.confirmEmail) {
        this.$el_alert_type(window.vm.$i18n.t("email.message"), "warning");
        return;
      }
      //验证邮箱是否存在
      this.$api
        .post("/register/checkIsRegistState", {
          email: this.email
        })
        .then(response => {
          if (response.data == 0) {
            this.$el_alert_type(window.vm.$i18n.t("js.emailNone"), "warning");
            return;
          } else {
            //发送修改密码邮件
            this.$api
              .post("/register/sendCheckEmail", {
                activatePurpose: 1,
                email: this.email,
                languageType: this.$lang(),
                domainName: window.location.host
              })
              .then(
                this.$router.push({
                  path: "/home/register_email",
                  query: {
                    activatePurpose: "1",
                    email: this.email
                  }
                })
              );
          }
        });
    },
    returnButton: function() {
      //返回主页
      this.$router.push("/");
      //刷新页面
      window.location.reload();
    }
  }
};
</script>
<style scoped>
.email_page {
  min-width: 1200px;
  min-height: 800px;
  /* background-color: #000; */
  /* background-image: url(../../../static/images/bg/ball_bg.jpg); */
  background-repeat: no-repeat;
  background-size: cover;
  /* position: relative; */
  background-position: center center;
}

.email_page .email_page_filter {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.5);
}

.email_content {
  width: 800px;
  height: 600px;
  margin: 0 auto;
  padding-top: 120px;
  position: relative;
}

.email_box {
  width: 500px;
  padding: 40px;
  margin: 0 auto;
  margin-top: 60px;
  background-color: rgba(50, 50, 50, 1);
  border-radius: 20px;
  position: relative;
  z-index: 1000;
}

.email_box .logo_font p {
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-family: myFont2;
  font-size: 21px;
  color: #fafafa;
  margin-bottom: 20px;
}

.email_box .logo_font p span {
  font-family: braggadocio;
  font-size: 21px;
  color: #ff5252 !important;
}
.email_left {
  text-align: left;
  color: #fff;
}

.email_left > p {
  font-size: 12px;
  margin-bottom: 15px;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}
.email_left > .warning {
  color: red !important;
}
.email_center {
  text-align: center;
  color: #fff;
}

.email_center > p {
  font-size: 12px;
  margin-bottom: 15px;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.email_center > .input {
  width: 317px;
  height: 30px;
  background-color: rgba(184, 184, 184, 0.28);
  border-radius: 15px;
  /*opacity: 0.28;*/
  position: relative;
  margin: 0 auto;
}

.email_center > .input > input {
  width: 82%;
  margin-left: 32px;
  height: 30px;
  line-height: 30px;
  vertical-align: middle;
  background-color: transparent;
  border: none;
  color: #ffffff;
  outline: none;
  opacity: 1;
  font-size: 13px;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.email_center > .input > input:focus {
  border: 0 !important;
}

.email_center > .input > img {
  position: absolute;
  width: 17px;
  top: 8px;
  left: 15px;
}

.email_center > .input > div {
  width: 1px;
  height: 13px;
  background-color: #7a7a7a;
  position: absolute;
  left: 38px;
  top: 8px;
}

button {
  width: 80px;
  padding: 6px 10px;
  font-size: 14px;
  color: #fff;
  border: 1px #fff solid;
  background: unset;
  border-radius: 20px;
  margin: 0 auto;
  margin-top: 50px;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
  transition: 0.5s ease;
}

button:hover {
  color: #000;
  background: #fff;
  transition: 0.5s ease;
}
</style>



// WEBPACK FOOTER //
// src/views/index/email.vue